interface IPrimaryButtonProps {
  className?: string
  children: React.ReactNode
  href: string
}

export const PrimaryButton: React.FC<IPrimaryButtonProps> = ({
  children,
  className,
  href,
}) => {
  return (
    <Link
      className={tw`primary-btn block w-fit rounded-lg px-6 py-3 font-semibold md:py-4 md:text-xl ${className}`}
      href={href}
    >
      {children}
    </Link>
  )
}
